import get from 'lodash/get';
import { createSelector } from 'reselect';

export const defaultFilters = {
    filterList: [],
    storeAvailabilityFilter: [],
};

export const selectFilters = (state) => state?.filters || defaultFilters;

export const selectFiltersList = createSelector([selectFilters], (filters) =>
    get(filters, 'filterList', defaultFilters?.filterList)
);

export const selectStoreAvailabilityFilter = createSelector([selectFilters], (filters) =>
    get(filters, 'storeAvailabilityFilter', defaultFilters?.storeAvailabilityFilter)
);

export default selectFilters;
